// extracted by mini-css-extract-plugin
module.exports = {"comparisonChartContainer":"styles_comparisonChartContainer__dJ3n5","tabs":"styles_tabs__WAwN8","emptyState":"styles_emptyState__v9if9","oneDayChart":"styles_oneDayChart__FSrtF"};